import { render } from "./share.vue?vue&type=template&id=1466f79c&scoped=true"
import script from "./share.vue?vue&type=script&lang=js"
export * from "./share.vue?vue&type=script&lang=js"

import "./share.vue?vue&type=style&index=0&id=1466f79c&lang=less&scoped=true"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1466f79c"]])

export default __exports__